import React from "react";
import { createPortal } from "react-dom";
import { PropelOverlay } from "./Overlay.style";
import { OverlayProps } from "./Overlay.types";

export const Overlay = ({
  children,
  isVisible,
  onClick,
  fullWidth,
}: OverlayProps) => {
  if (!isVisible) return null;

  return createPortal(
    <PropelOverlay
      onClick={onClick}
      fullWidth={fullWidth}
      isVisible={isVisible}
      className="propel-overlay"
      data-testid="overlay"
    >
      {children}
    </PropelOverlay>,
    document.body
  );
};
